import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { AxiosResponse } from 'axios';
import { API } from 'network/api';
import {
  Season,
  DataPagination,
  Address,
  CommonListParams,
} from 'types/common';

type Params = CommonListParams & {
  agronomist?: string;
  subDistrict?: string;
  country?: string;
  seasonTypeId?: string;
  groupType?: string;
  seasonStatus?: string;
};

export type TDashboard = {
  groupId: string;
  agronomistName: string;
  groupName: string;
  leaderId: string;
  leaderName: string;
  subDistrict: string;
  paddyBuyerName: string;
  participatedArea: number;
  participatedFarmers: number;
  ownedArea: number;
  totalFarmers: number;
  dap: number;
  season: Season;
  address: Address;
};

const useDashboardQuery = (params?: Params) => {
  const queryParams = useMemo(
    () => ({ offset: 1, paged: true, ...params }),
    [params],
  );
  const query = useQuery<AxiosResponse<DataPagination<TDashboard>>>({
    queryKey: ['dashboard-v2', queryParams],
    queryFn: () =>
      API.get('/dashboard/v2', {
        params: { ...queryParams },
      }),
    enabled: !!params?.country && !!params?.seasonTypeId,
  });

  return query;
};

export default useDashboardQuery;
